export { COPILOT_ACTION_RENDERERS } from "./registry";

export type ActionExecutionResult<T = unknown> = {
	type: "success" | "error";
	message: string;
	instructions?: string;
	result?: T;
};
